export default __webpack_public_path__ + "static/media/outbond-call.ce47c4b6.png";